import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Image, LinkButton, ShimmerBox, Text, ThumbnailButton } from '@common-fe/common-fe';

import { Receipt } from '@/modules/MyDocuments/myDocuments.types';

interface Props {
  isMobile?: boolean;
  receipts?: Receipt[];
  isReceiptsLoading?: boolean;
  onSelectFromSavedReceipts?: () => void;
}

const SavedReceiptsCard: React.FC<Props> = ({
  isMobile,
  receipts,
  isReceiptsLoading,
  onSelectFromSavedReceipts,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid="saved-receipts_wrapper"
      direction={isMobile ? 'column' : 'row'}
      margin={{ top: 'spacing12' }}
      pad="spacing24"
      background="module"
      round="container1Round"
      gap="spacing16"
    >
      {isReceiptsLoading ? <ShimmerBox width="192px" height="72px" data-testId="saved-receipts_loader" /> : (
        <Box direction="row" data-testid="saved-receipt_items">
          {receipts?.map((receipt, index) => (
            <Box
              key={receipt?.id}
              style={{
                position: 'relative',
                marginLeft: index > 0 ? '-12px' : '0',
                zIndex: receipts.length - index,
              }}
            >
              <ThumbnailButton testId={`saved-receipt_item-${index}`}>
                <Image
                  src={receipt?.fileUrl}
                  width="100%"
                  height="100%"
                />
              </ThumbnailButton>
            </Box>
          ))}
        </Box>
      )}

      <Box>
        <Text weight={700}>
          {t('Already uploaded your document?')}
        </Text>
        <Text margin={{ top: 'spacing2' }} color="textSecondary">
          {t('Select a file from your saved receipts')}
        </Text>
        <LinkButton
          testId="select-from-saved-receipts"
          onClick={onSelectFromSavedReceipts}
          linkInlineMode
        >
          {t('Select From Your Saved Receipts')}
        </LinkButton>
      </Box>
    </Box>
  );
};

export default SavedReceiptsCard;
